import resizeCards from './cards';
import revealCards from './revealMore';

// Used for product rendering when sorting and filtering

export default function productReload() {
   
    resizeCards(document.querySelectorAll('.card--item'));
    revealCards();
}


// WEBPACK FOOTER //
// ./scripts/components/product-cards.js